export default __webpack_public_path__ + "static/media/android-chrome-512x512.1729afa2.png";